import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { GUIDANCE } from './financeUtils';

export const GuidanceBanner = () => {
  const [idx, setIdx] = useState(new Date().getDate() % GUIDANCE.length);
  const [paused, setPaused] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    if (paused) return undefined;
    timer.current = setInterval(() => setIdx((i) => (i + 1) % GUIDANCE.length), 12000);
    return () => clearInterval(timer.current);
  }, [paused]);
  const m = GUIDANCE[idx];
  const Icon = m.icon;
  const go = (d) => setIdx((i) => (i + d + GUIDANCE.length) % GUIDANCE.length);
  return (
    <section
      className="flex items-center gap-3 p-4 rounded-2xl border border-emerald-200 border-l-4 border-l-emerald-600 bg-gradient-to-r from-emerald-50 to-green-50"
      onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}
      onTouchStart={() => setPaused(true)} data-testid="finance-guidance"
    >
      <div className="w-10 h-10 shrink-0 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center"><Icon className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <p className="text-[10px] uppercase tracking-wider font-bold text-emerald-700">{m.label}</p>
        <p key={idx} className="text-sm font-semibold text-emerald-950 leading-snug animate-in fade-in" aria-live="polite" data-testid="finance-guidance-message">{m.text}</p>
      </div>
      <div className="flex flex-col gap-1">
        <button type="button" onClick={() => go(-1)} aria-label="Mensagem anterior" className="w-7 h-7 rounded-lg border border-emerald-200 bg-white flex items-center justify-center text-emerald-700" data-testid="finance-guidance-prev"><ChevronLeft className="w-4 h-4" /></button>
        <button type="button" onClick={() => go(1)} aria-label="Próxima mensagem" className="w-7 h-7 rounded-lg border border-emerald-200 bg-white flex items-center justify-center text-emerald-700" data-testid="finance-guidance-next"><ChevronRight className="w-4 h-4" /></button>
      </div>
    </section>
  );
};
